<template>
  <Navbar />
  <div class="page-container">
    <a-spin v-if="isRedirecting" class="loading-spinner" />
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import Navbar from "../components/Navbar.vue";
import { onMounted, ref } from "vue";

const router = useRouter();
const isRedirecting = ref(true);

// 2026-08-06：信箱驗證頁面已棄用
// 保留路由以避免舊信件中的連結失效
// 直接導向 /phone-validate 進行手機簡訊驗證
onMounted(() => {
  const token = localStorage.getItem("ms_platform_token");
  if (token) {
    router.replace("/bind-mobile");
  } else {
    router.replace("/phone-validate");
  }
});
</script>

<style scoped>
.page-container {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-spinner {
  font-size: 24px;
}
</style>
